import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ElementoItemForm from "../../../components/forms/ElementoItemForm.vue";
import { ElementoItemService } from "../../../services/ElementoItemService";

export default {
    name: "EditarElementoItem",
    components: {
        Breadcrumb,
        ElementoItemForm,
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Configuração',
                disabled: false,
                href: '/gerenciar-elementos-itens',
            },
            {
                text: 'Editar Elemento Item',
                disabled: true
            }
        ],
        elementoItemData: {
            exercicio: '',
            codigoElementoItem: '',
            descricao: '',
            ativo: false
        },
    }),
    computed: {
        elementoItemId() {
            return this.$route.params.id;
        }
    },
    async created() {
        await this.carregarElementoItem();
    },
    methods: {
        async carregarElementoItem() {
            try {
                const response = await ElementoItemService.show(this.elementoItemId);

                if (response && response.data) {
                    const data = response.data;
                    
                    // Mapear dados da API para o formato esperado pelo ElementoItemForm
                    this.elementoItemData = {
                        exercicio: data.exercicio?.ano || data.exercicio || '',
                        codigoElementoItem: data.codigo_elemento_item || '',
                        descricao: data.descricao || '',
                        ativo: data.ativo !== undefined ? data.ativo : true
                    };
                    
                } else {
                    console.error('Não foi possível carregar os dados do Elemento Item.');
                }
            } catch (error) {
                console.error('Erro ao carregar Elemento Item:', error);
            }
        },
        
        async handleSave(formData) {
            try {
                // Verificação de segurança - garantir que todos os campos obrigatórios estejam preenchidos
                if (!formData.exercicio || !formData.codigoElementoItem || !formData.descricao) {
                    console.error('Campos obrigatórios não preenchidos:', {
                        exercicio: formData.exercicio,
                        codigoElementoItem: formData.codigoElementoItem,
                        descricao: formData.descricao
                    });
                    return;
                }
                
                const dataToSend = new FormData();
                dataToSend.append("exercicio", formData.exercicio);
                dataToSend.append("codigo_elemento_item", formData.codigoElementoItem);
                dataToSend.append("descricao", formData.descricao);
                dataToSend.append("ativo", formData.ativo ? 1 : 0);

                const response = await ElementoItemService.update(this.elementoItemId, dataToSend);

                if (response) {
                    this.$router.push('/gerenciar-elementos-itens');
                } else {
                    this.$globalAlert('Erro ao atualizar elemento item');
                }
            } catch (error) {
                console.error('Erro ao salvar elemento item:', error);
                this.$globalAlert('Erro ao atualizar elemento item. Tente novamente.');
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-elementos-itens');
        }
    }
};
